import { TenantEntity } from '../TenantEntity'

/**
 * 报关VO
 */
export class CustomsInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get customsId() {
    return this._data.customsId
  }
  set customsId(customsId) {
    this._data.customsId = customsId
  }
  get customsBroker() {
    return this._data.customsBroker
  }
  set customsBroker(customsBroker) {
    this._data.customsBroker = customsBroker || 0
  }
  get companyCname() {
    return this._data.companyCname
  }
  set companyCname(companyCname) {
    this._data.companyCname = companyCname
  }
  get tenDigitCode() {
    return this._data.tenDigitCode
  }
  set tenDigitCode(tenDigitCode) {
    this._data.tenDigitCode = tenDigitCode
  }
  get inspectionCode() {
    return this._data.inspectionCode
  }
  set inspectionCode(inspectionCode) {
    this._data.inspectionCode = inspectionCode
  }
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    this._data.hsCode = hsCode
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get customsDate() {
    return this._data.customsDate
  }
  set customsDate(customsDate) {
    this._data.customsDate = customsDate
  }
  get level() {
    return this._data.level
  }
  set level(level) {
    this._data.level = level
  }
  get declareCustomsState() {
    return this._data.declareCustomsState
  }
  set declareCustomsState(declareCustomsState) {
    this._data.declareCustomsState = declareCustomsState || 0
  }
  get commodityInspection() {
    return this._data.commodityInspection
  }
  set commodityInspection(commodityInspection) {
    this._data.commodityInspection = commodityInspection || false
  }
  get spotInspection() {
    return this._data.spotInspection
  }
  set spotInspection(spotInspection) {
    this._data.spotInspection = spotInspection || false
  }
  get quantityActual() {
    return this._data.quantityActual
  }
  set quantityActual(quantityActual) {
    this._data.quantityActual = quantityActual || 0
  }
  get weightActual() {
    return this._data.weightActual
  }
  set weightActual(weightActual) {
    this._data.weightActual = weightActual || 0.0
  }
  get cubageActual() {
    return this._data.cubageActual
  }
  set cubageActual(cubageActual) {
    this._data.cubageActual = cubageActual || 0.0
  }
  get soNo() {
    return this._data.soNo
  }
  set soNo(soNo) {
    this._data.soNo = soNo
  }
  get customsNo() {
    return this._data.customsNo
  }
  set customsNo(customsNo) {
    this._data.customsNo = customsNo
  }
  get declareCustomsType() {
    return this._data.declareCustomsType
  }
  set declareCustomsType(declareCustomsType) {
    this._data.declareCustomsType = declareCustomsType || 0
  }
  get preNumber() {
    return this._data.preNumber
  }
  set preNumber(preNumber) {
    this._data.preNumber = preNumber
  }
  get plateNumber() {
    return this._data.plateNumber
  }
  set plateNumber(plateNumber) {
    this._data.plateNumber = plateNumber
  }
  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    this._data.containerNo = containerNo
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get noticeBgh() {
    return this._data.noticeBgh
  }
  set noticeBgh(noticeBgh) {
    this._data.noticeBgh = noticeBgh
  }
  get declareTime() {
    return this._data.declareTime
  }
  set declareTime(declareTime) {
    this._data.declareTime = declareTime
  }
  get xhqCustomState() {
    return this._data.xhqCustomState
  }
  set xhqCustomState(xhqCustomState) {
    this._data.xhqCustomState = xhqCustomState
  }
  get ifXhqCustomsDataReceived() {
    return this._data.ifXhqCustomsDataReceived
  }
  set ifXhqCustomsDataReceived(ifXhqCustomsDataReceived) {
    this._data.ifXhqCustomsDataReceived = ifXhqCustomsDataReceived
  }

  get customsDeclarationNo() {
    return this._data.customsDeclarationNo
  }
  set customsDeclarationNo(customsDeclarationNo) {
    this._data.customsDeclarationNo = customsDeclarationNo
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity
  }
  get number() {
    return this._data.number
  }
  set number(number) {
    this._data.number = number
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight
  }
  get rate() {
    return this._data.rate
  }
  set rate(rate) {
    this._data.rate = rate
  }
  get systemFee() {
    return this._data.systemFee
  }
  set systemFee(systemFee) {
    this._data.systemFee = systemFee
  }
  get insurancePremium() {
    return this._data.insurancePremium
  }
  set insurancePremium(insurancePremium) {
    this._data.insurancePremium = insurancePremium
  }
  get processingFee() {
    return this._data.processingFee
  }
  set processingFee(processingFee) {
    this._data.processingFee = processingFee
  }
  get freeOnBoard() {
    return this._data.freeOnBoard
  }
  set freeOnBoard(freeOnBoard) {
    this._data.freeOnBoard = freeOnBoard
  }
  get pushOrNot() {
    return this._data.pushOrNot
  }

  set pushOrNot(pushOrNot) {
    this._data.pushOrNot = pushOrNot || false
  }

  get verificationSheetRequired() {
    return this._data.verificationSheetRequired
  }

  set verificationSheetRequired(verificationSheetRequired) {
    this._data.verificationSheetRequired = verificationSheetRequired || false
  }

  // 空对象转换为null
  emptyObjectToNull() {
    const data = this._data
    data.businessDocuments = data.businessDocuments || null
    data.job = data.job || null
  }
}
